import { createSolid } from '@web-stories-wp/patterns';
import {
  getNormalizedTextListStyle,
  isSingleGrapheme,
  syncTextListMarkerSize,
} from './listStyle';

const LIMITS = {
  opacity: [0, 100],
  size: [1, 500],
  baselineShift: [-500, 500],
  horizontalShift: [-500, 500],
  markerGap: [0, 200],
  indent: [0, 500],
  nestedIndent: [0, 500],
  itemSpacing: [0, 500],
};

// Validate the optional tenant response once, before passing it to the editor.
export function isValidTenantBulletDefaults(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  if (
    value.marker != null &&
    !['disc', 'circle', 'square', 'custom'].includes(value.marker)
  )
    return false;
  if (value.marker === 'custom' && !isSingleGrapheme(value.glyph)) return false;
  if (value.glyph != null && value.marker !== 'custom') return false;
  if (
    value.color != null &&
    (typeof value.color !== 'string' || !/^#[0-9a-f]{6}$/i.test(value.color))
  )
    return false;
  if (
    value.sizeRatio != null &&
    (!Number.isFinite(value.sizeRatio) ||
      value.sizeRatio <= 0 ||
      value.size != null)
  )
    return false;
  return Object.entries(LIMITS).every(
    ([key, [min, max]]) =>
      value[key] == null ||
      (Number.isFinite(value[key]) && value[key] >= min && value[key] <= max)
  );
}

export function captureTenantBulletDefaults(element, defaults) {
  if (element.type !== 'text' || !isValidTenantBulletDefaults(defaults))
    return element;
  const color = defaults.color
    ? createSolid(
        parseInt(defaults.color.slice(1, 3), 16),
        parseInt(defaults.color.slice(3, 5), 16),
        parseInt(defaults.color.slice(5, 7), 16),
        (defaults.opacity ?? 100) / 100
      )
    : undefined;
  const listStyle = getNormalizedTextListStyle(
    {
      version: 1,
      marker: {
        preset: defaults.marker,
        glyph: defaults.glyph,
        color,
        size: defaults.size,
        sizeRatio: defaults.sizeRatio,
        baselineShift: defaults.baselineShift,
        horizontalShift: defaults.horizontalShift,
      },
      markerGap: defaults.markerGap,
      indent: defaults.indent,
      nestedIndent: defaults.nestedIndent,
      itemSpacing: defaults.itemSpacing,
    },
    element.fontSize
  );
  return syncTextListMarkerSize({ ...element, listStyle });
}
